import React, { useState, useEffect } from "react";
import { Rating } from "react-simple-star-rating";
import ReviewListItem from "./ListItem";
import { getListReviews } from "../../API/ServiceAPI";

const ReviewList = ({venueId}) => {
  const [loading, setLoading] = useState(true);
  const [ratings, setRatings] = useState({});
  const [reviews, setReviews] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  
  useEffect(() => {
    const onSuccessHandler = (responseJSON) => {
      setReviews(responseJSON.service_ratings);
      setRatings(responseJSON.data_ratings);
      setPagination(responseJSON.pagination);
      setLoading(false);
    }
    const onFailureHandler = (messages) => console.debug("FAIL", messages);
    getListReviews({venueId: venueId, page: page}, onSuccessHandler, onFailureHandler);
  }, [venueId, page]);

  if (loading || reviews.length === 0)
    return null;

  let ratingText = "";
  if (ratings.total_ratings < 2) {
    ratingText = "Buruk";
  }
  else if (ratings.total_ratings < 3) {
    ratingText = "Cukup";
  }
  else if (ratings.total_ratings < 4) {
    ratingText = "Baik";
  }
  else if (ratings.total_ratings < 5) {
    ratingText = "Baik Sekali";
  }
  else if (ratings.total_ratings >= 5) {
    ratingText = "Super";
  }

  return (
    <>
    {/* Venue Details Review */}
    <div className="flex flex-col overflow-hidden rounded-2xl mt-6 px-6 md:px-[40px] bg-white pt-[37px] pb-[37px]">
      <div className='flex w-full justify-between mb-6'>
        <p className='font-bold text-md tracking-wide text-gray-800'>Review User</p>
        <div className="flex gap-1">
          {(pagination.prev_page !== "") && (
            <button className='col-span-2 text-white px-3 py-2 bg-primaryRed rounded-lg text-xs font-semibold' onClick={(e) => setPage(pagination.prev_page)}>&lt;</button>
          )}
          {(pagination.next_page !== "") && (
            <button className='col-span-2 text-white px-3 py-2 bg-primaryRed rounded-lg text-xs font-semibold' onClick={(e) => setPage(pagination.next_page)}>&gt;</button>
          )}
        </div>
      </div>

      <div className='flex flex-col md:flex-row gap-x-8 mb-4'>
        <div className='border border-amber-500 rounded-md overflow-hidden md:w-[147px] h-[137px] mb-8 md:mb-0'>
          <p className='flex font-bold items-center justify-center text-4xl text-amber-500 w-full h-[101px]'>{ratings.total_ratings}</p>
          <p className='flex items-center justify-center text-2xl text-gray-800 bg-amber-500 w-full h-[36px] text-sm font-semibold'>{ratingText}</p>
        </div>

        <div className='flex flex-grow flex-col'>
          <p className='font-bold text-md tracking-wide text-gray-800 mb-4'>Berdasarkan {ratings.total_reviews} Ulasan</p>

          <div className='grid w-full md:grid-cols-2 md:gap-x-8 gap-y-3'>

            <div className='flex justify-between items-center'>
              <p className='font-semibold text-xs text-gray-800'>Kondisi Lapangan</p>
              {/* star rating  */}
              <Rating
                className='-mt-1'
                transition
                size={25}
                fillColor='#ffaa00'
                allowHover={false}
                readonly
                initialValue={ratings.venue_condition}
                allowFraction
              />
            </div>

            <div className='flex justify-between items-center'>
              <p className='font-semibold text-xs text-gray-800'>Keamanan</p>
              {/* star rating  */}
              <Rating
                className='-mt-1'
                transition
                size={25}
                fillColor='#ffaa00'
                allowHover={false}
                readonly
                initialValue={ratings.security}
                allowFraction
              />
            </div>

            <div className='flex justify-between items-center'>
              <p className='font-semibold text-xs text-gray-800'>Kebersihan</p>
              {/* star rating  */}
              <Rating
                className='-mt-1'
                transition
                size={25}
                fillColor='#ffaa00'
                allowHover={false}
                readonly
                initialValue={ratings.clean}
                allowFraction
              />
            </div>

            <div className='flex justify-between items-center'>
              <p className='font-semibold text-xs text-gray-800'>Akses Transportasi</p>
              {/* star rating  */}
              <Rating
                className='-mt-1'
                transition
                size={25}
                fillColor='#ffaa00'
                allowHover={false}
                readonly
                initialValue={ratings.transportation_access}
                allowFraction
              />
            </div>

            <div className='flex justify-between items-center'>
              <p className='font-semibold text-xs text-gray-800'>Kelengkapan Fasilitas</p>
              {/* star rating  */}
              <Rating
                className='-mt-1'
                transition
                size={25}
                fillColor='#ffaa00'
                allowHover={false}
                readonly
                initialValue={ratings.facilities}
                allowFraction
              />
            </div>

          </div>
        </div>
      </div>

      {/* reviews  */}
      <div className='flex flex-col w-full mt-4 gap-y-4'>
        {reviews.map((review, index) => 
          <ReviewListItem 
            key={index} 
            name={review.contact_name} 
            review={review.description} />)}
      </div>
    </div>
    </>
  );
}

export default ReviewList;